module.exports = __webpack_public_path__ + "static/media/11.d2e83118.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/stickers/11.png
// module id = 117
// module chunks = 0